export default "__VITE_ASSET__pX_HZl_i__"